import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import Money from '../../components/Money';
import BookingFee from './BookingFee';
import { taxBreakdownArray } from '../../shapes';

const TaxesAndFees = ({
  taxes,
  fees,
  isSquireFeeShop,
  isChopMurrayHillShop,
  taxBreakdown,
}) => {
  if (isSquireFeeShop) {
    return (
      <div>
        <div className="c-order-info__desc">Squire Fee:</div>
        <div className="c-order-info__price"><Money>{taxes + fees}</Money></div>
      </div>
    );
  }
  return (
    <div>
      {Boolean(taxes) && taxBreakdown.length === 1 && <div className="c-order-info__desc">Taxes:</div>}
      {Boolean(taxes) && taxBreakdown.length === 1 && <div className="c-order-info__price"><Money>{taxes}</Money></div>}
      {taxBreakdown.length > 1 && map(taxBreakdown, tax => (
        <div>
          <div className="c-order-info__desc">{tax.name}:</div>
          <div className="c-order-info__price"><Money>{tax.amount}</Money></div>
        </div>
      ))}
      <BookingFee
        fees={fees}
        isChopMurrayHillShop={isChopMurrayHillShop}
      />
    </div>
  );
};
TaxesAndFees.propTypes = {
  isSquireFeeShop: PropTypes.bool.isRequired,
  taxes: PropTypes.number,
  fees: PropTypes.number,
  isChopMurrayHillShop: PropTypes.bool.isRequired,
  taxBreakdown: taxBreakdownArray,
};
TaxesAndFees.defaultProps = {
  taxes: 0,
  fees: 0,
  taxBreakdown: [],
};

export default TaxesAndFees;



// WEBPACK FOOTER //
// ./src/app/reservation/components/TaxesAndFees.jsx